export const BuildingIcon = () => {
  return (
    <svg
      width="28"
      height="29"
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 25.6369V9.21187C0 8.50063 0.248625 7.8955 0.745875 7.3965C1.24312 6.8975 1.84613 6.648 2.55487 6.648H9.2625V4.45838C9.2625 4.11138 9.32475 3.7805 9.44925 3.46575C9.57375 3.15075 9.76338 2.88137 10.0181 2.65762L12.0146 0.727126C12.5021 0.242376 13.098 0 13.8023 0C14.5068 0 15.1044 0.242376 15.5951 0.727126L17.5826 2.63963C17.8374 2.87538 18.03 3.15288 18.1605 3.47213C18.291 3.79163 18.3563 4.12637 18.3563 4.47637V12.873H25.0549C25.7661 12.873 26.3713 13.1225 26.8703 13.6215C27.3692 14.1205 27.6188 14.7256 27.6188 15.4369V25.6369C27.6188 26.3456 27.3692 26.9486 26.8703 27.4459C26.3713 27.9431 25.7661 28.1917 25.0549 28.1917H2.55487C1.84613 28.1917 1.24312 27.9431 0.745875 27.4459C0.248625 26.9486 0 26.3456 0 25.6369ZM2.55487 25.6369H6.52988V21.6619H2.55487V25.6369ZM2.55487 19.4119H6.52988V15.4369H2.55487V19.4119ZM2.55487 13.1869H6.52988V9.21187H2.55487V13.1869ZM11.8174 25.6369H15.7924V21.6619H11.8174V25.6369ZM11.8174 19.4119H15.7924V15.4369H11.8174V19.4119ZM11.8174 13.1869H15.7924V9.21187H11.8174V13.1869ZM11.8174 6.96188H15.7924V2.98688H11.8174V6.96188ZM21.0799 25.6369H25.0549V21.6619H21.0799V25.6369ZM21.0799 19.4119H25.0549V15.4369H21.0799V19.4119Z"
        fill="black"
      />
    </svg>
  );
};
